import React from 'react';
import './App.css';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';

export default class SmartCollect extends React.Component {
    constructor(props) {
        super(props);
        this.downloadQr = this.downloadQr.bind(this);
        this.copyAccountInfo = this.copyAccountInfo.bind(this);
    }

    copyAccountInfo() {
        let textToCopy = 'Bank Name: ' + this.props.bank.bank_name + '\nIFSC Code:' + this.props.bank.ifsc + '\nBeneficiary Name: ' + this.props.bank.name + '\nAccountNumber: ' + this.props.bank.account_number + '\nPayment Amount: ₹' + this.props.totalAmount;
        navigator.clipboard.writeText(textToCopy);
    }

    downloadQr() {
        let orderId = this.props.orderId
        fetch(this.props.upiQr)
            .then(response => {
                response.arrayBuffer().then(function (buffer) {
                    const url = window.URL.createObjectURL(new Blob([buffer]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", 'one-time-tangent-payment-order-' + orderId + '.png');
                    document.body.appendChild(link);
                    link.click();
                });
            })
            .catch(err => {
                alert('We\'re unable to save this QR Code. We apologize for the inconvenience')
            });
    }

    render() {
        if (!this.props.bank) {
            return <div style={{display: 'flex', justifyContent: 'center'}} className='mid-margin'><CircularProgress/>
            </div>
        }

        let classes = window.innerWidth > 500 ? 'center mid-margin' : 'center mid-margin medium';

        return (
            <div className={classes}>
                <p>Please copy these details and make the payment to this account. Once you do so, your order will
                    automatically be updated to reflect this payment.</p>
                <hr/>
                <table>
                    {this.props.type === 'upi' || <tbody>
                    <tr>
                        <td colSpan={2} style={{textAlign: 'center'}}>
                            <p className='medium'><em><strong>This is a one-time Bank Account and has not been used in the past. You will need to register this account with your bank before making online transfers. Please do not use this Bank Account for future payments</strong></em></p>
                        </td>
                    </tr>
                        <tr>
                            <th colSpan={2}>Bank Account</th>
                        </tr>
                        <tr>
                            <td>Bank Name:</td>
                            <td>{this.props.bank.bank_name}</td>
                        </tr>
                        <tr>
                            <td>IFSC Code:</td>
                            <td>{this.props.bank.ifsc}</td>
                        </tr>
                        <tr>
                            <td>Beneficiary Name:</td>
                            <td>{this.props.bank.name}</td>
                        </tr>
                        <tr>
                            <td>Account Number:</td>
                            <td>{this.props.bank.account_number}</td>
                        </tr>
                        <tr>
                            <td>Payment Amount:</td>
                            <td>₹{this.props.totalAmount}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <Button variant="contained" onClick={this.copyAccountInfo}>Copy Account Information</Button>
                            </td>
                        </tr>
                    </tbody>}
                    {this.props.type === 'upi' && <tbody>
                    <tr>
                        <td colSpan={2} style={{textAlign: 'center'}}>
                            <p className='medium'><em><strong>This is a one-time QR Code. Please do not use this QR for future payments</strong></em></p>
                        </td>
                    </tr>
                        <tr>
                            <td colSpan={2} style={{textAlign: 'center'}}>
                                <img src={this.props.upiQr} alt='One Time QR Code'/>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{textAlign: 'center'}}>
                                <Button variant="contained" onClick={this.downloadQr}>Save QR Code</Button>
                            </td>
                        </tr>
                    </tbody>}
                </table>
                <Divider/>
                <p className="medium"><em><strong>This account is unique to this order. Please do not use this account for any
                    other payments to Tangent India</strong></em></p>
            </div>
        );
    }
}